/**
 * @generated SignedSource<<d2c83ae7b0e6e9328ff3702f9aa30474>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetNameScreenMutation$variables = {
  name: string;
};
export type SetNameScreenMutation$data = {
  readonly me: {
    readonly setName: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type SetNameScreenMutation = {
  response: SetNameScreenMutation$data;
  variables: SetNameScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "setName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetNameScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetNameScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d54b491977249bb32b6345b0da79f138",
    "id": null,
    "metadata": {},
    "name": "SetNameScreenMutation",
    "operationKind": "mutation",
    "text": "mutation SetNameScreenMutation(\n  $name: String!\n) {\n  me {\n    setName(name: $name) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "89cf3e6229e0953f70e62787b49b75f7";

export default node;
